goog.provide("shadow.js.shim.module$src$svg$editor$objects$link_svg$default");
shadow.js.shim.module$src$svg$editor$objects$link_svg$default = shadow.js.shim.module$src$svg$editor$objects$link_svg.default;
